import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Option,
  Select,
  Switch,
  Textarea,
  Typography
} from "@material-tailwind/react";
import Dict from "../../helper/dict";
import React, {useEffect, useState} from "react";
import "../../style/datePicker.css"
import {submitBranchDiscount, updateBranchDiscount} from "../../services/branch_discount/branch_discount";
import {getFieldBranches} from "../../services/branch/branch";
import SelectInput from "../system/select";
import DateField from "../system/dateField";
import Validator from "../../helper/validator/Validator";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {ValidatorProvider} from "../../helper/validator/ValidatorContext";
import {Toaster} from "../../helper/Toaster";
import {checkAll} from "../../helper/validator/Check";

export function BranchDiscountForm({branchDiscount, open, setOpen, setLastDataRefresh, setGridSelectedRow}) {

  const handleOpen = () => setOpen(!open);

  const [id, setId] = useState(null)
  const [branchId, setBranchId] = useState(null)
  const [type, setType] = useState("")
  const [code, setCode] = useState("")
  const [percentage, setPercentage] = useState(null)
  const [discountValue, setDiscountValue] = useState(null)
  const [branchCommission, setBranchCommission] = useState(null)
  const [expirationDate, setExpirationDate] = useState("")
  const [description, setDescription] = useState("")
  const [status, setStatus] = useState(false)
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    setId(branchDiscount?.id ?? null)
    setBranchId(branchDiscount?.branch_id ?? null)
    setType(branchDiscount?.type ?? "")
    setCode(branchDiscount?.code ?? "")
    setPercentage(branchDiscount?.percentage ?? null)
    setDiscountValue(branchDiscount?.value ?? null)
    setExpirationDate(branchDiscount?.expiration_date ?? "")
    setDescription(branchDiscount?.description ?? "")
    setStatus(branchDiscount?.status === 'enable' ? true : false ?? false)
  }, [branchDiscount]);

  const save = async () => {
    const data = {
      branch_id: branchId,
      type: type,
      code: code,
      percentage: parseInt(percentage),
      value: parseInt(discountValue),
      expiration_date: expirationDate,
      description: description,
      status: status ? "enable" : "disable"
    };
    const res = checkAll();
    if (!res) {
      Toaster.failure(null,
        <Typography variant="small">
          مقادیر الزامی را بر اساس راهنما تکمیل کنید
        </Typography>);
      return
    }
    let result;

    if (!id) {
      result = await submitBranchDiscount(data);
    } else {
      data.id = id
      result = await updateBranchDiscount(data);
    }

    if (result.status === 200) {
      setGridSelectedRow(false)
      setLastDataRefresh(Date.now())
      handleOpen()
    }
  };

  return (
    <ValidatorProvider>
      <>
        <Dialog open={open} handler={handleOpen} animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
          <DialogHeader className="border-b">
            <Typography>ویرایش / ایجاد کد تخفیف</Typography>
          </DialogHeader>
          <DialogBody className="flex flex-col gap-4 overflow-y-scroll">

            <div className="mb-4">
              <SelectInput
                label={Dict("select_branch")}
                defaultValue={branchId}
                multiselect={false}
                autoLoadService={getFieldBranches}
                autoLoadRender={({field_title, title}) => {
                  return field_title + " - " + title
                }}
                onChange={setBranchId}
              />
              {/*<Validator isChecked={isChecked} state={branchId} rules="num"/>*/}
            </div>

            <div className="flex w-full mb-4">
              <Select variant="static" className="rtl" style={{label: {left: ""}}}
                      label={Dict('service_type')}
                      value={type}
                      onChange={(val) => setType(val)}>
                <Option value="consultation">مشاوره</Option>
                <Option value="service">خدمات</Option>
              </Select>
            </div>

            <div className="mb-4">
              <Input variant="standard"
                     value={code}
                     label={Dict('discount_code')}
                     placeholder={Dict('discount_code')}
                     onChange={(e) => {
                       setCode(e.target.value)
                     }}
              />
              <Validator isChecked={isChecked} state={code} rules="required"/>
              <Validator isChecked={isChecked} state={code} rules="alphanumeric"/>
            </div>

            <div className="mb-4">
              <Input variant="standard"
                     value={percentage}
                     type="number"
                     label={Dict('discount_percentage')}
                     placeholder={Dict('discount_percentage')}
                     onChange={(e) => {
                       setPercentage(e.target.value)
                     }}
              />
              <Validator isChecked={isChecked} state={percentage} rules="required"/>
              <Validator isChecked={isChecked} state={percentage} rules="num"/>
            </div>

            <div className="mb-4">
              <Input variant="standard"
                     value={discountValue}
                     type="number"
                     label={Dict('discount_value')}
                     placeholder={Dict('discount_value')}
                     onChange={(e) => {
                       setDiscountValue(e.target.value)
                     }}
              />
              {discountValue && !isNaN(discountValue) &&
                <Typography color="blue-gray" className="flex w-full mb-4">
                  {persianNumberFormat(discountValue, true) + " " + "ریال"}
                </Typography>
              }
              <Validator isChecked={isChecked} state={discountValue} rules="required"/>
              <Validator isChecked={isChecked} state={discountValue} rules="num"/>
            </div>

            <div className="flex w-full mb-4">
              <DateField
                className="my-4 mx-4 w-full"
                date={expirationDate}
                setDate={setExpirationDate}
                label={Dict("expiration_date")}
              />
            </div>

            <div className="mb-4">
              <Textarea variant="standard"
                        value={description}
                        label="توضیحات"
                        placeholder="توضیحات"
                        onChange={(e) => {
                          setDescription(e.target.value)
                        }}
              />
              {description.length > 0 &&
                <Validator isChecked={isChecked} state={description} rules="alphanumeric"/>
              }
            </div>

            <div className="">
              <Switch
                label={
                  <Typography color="blue-gray" className="font-medium">
                    فعال/غیرفعال
                  </Typography>
                }
                checked={status}
                onChange={(e) => {
                  setStatus(e.target.checked)
                }}
                labelProps={{className: "mx-4"}}
              />
            </div>
          </DialogBody>
          <DialogFooter className="space-x-2">
            <Button variant="gradient" color="gray" onClick={save} className="ml-1">
              <span>ذخیره</span>
            </Button>
            <Button variant="text" color="gray" onClick={handleOpen}>
              <span>انصراف</span>
            </Button>
          </DialogFooter>
        </Dialog>
      </>
    </ValidatorProvider>
  );
}